import { render, staticRenderFns } from "./MobileMoneyModal.vue?vue&type=template&id=08377b7d&"
import script from "./MobileMoneyModal.vue?vue&type=script&lang=js&"
export * from "./MobileMoneyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports